<template id="content">
    <div v-if="$store.state.is_manager">
        <div class="edit-document-button" :class="scroll.headerFixed?'fix-button-top':''">
            <el-button type="success" @click="addContent" icon="el-icon-check" class="circle-button"
                       title="保存"></el-button>
        </div>
        <div class="document-title">
            <el-row style="height: 60px;">
                <el-col :span="20">
                    <input placeholder='标题' style="outline:none" class='documentTitle' v-model="currentTitle"/>
                </el-col>
            </el-row>
        </div>
        <hr>
        <div class="toolbar" id="toolbar"></div>
        <div class="wrapper">
            <div class="editor" id="editor" ref="content"></div>
        </div>
    </div>
</template>


<script>
    import {Editor} from "@mtfe/citadel-editor"
    import {buildToolbar} from "@mtfe/citadel-editor/lib/toolbar"
    import axios from "axios"
    import {mapState} from "vuex"


    export default {
        name: "editorItem",
        mounted: function () {
            window.addEventListener('scroll', this.handleScroll);
            var vm = this;
            if (!(vm.$store.state.is_manager)) {
                this.$notify({
                    title: '没有权限',
                    message: '你没有操作当前菜单的权限',
                    type: 'error'
                });
                return;
            }
            if (vm.token === "") {
                var token = this.getCookie("access-token");
                if (token != null) {
                    vm.$store.commit('UPDATETOKEN', token);
                    vm.token = token;
                }
            }
            vm.currentIndex = vm.$route.query.index;
            vm.currentTitle = vm.$route.query.title;
            vm.item = vm.$route.query.item;
            const $editor = document.querySelector("#editor");
            const $toolbarWrapper = document.querySelector("#toolbar");
            const editor = new Editor($editor, {
                defaultValue: '<h1>在此编辑内容</h1><p></p><p></p><p></p><p></p><p></p><p></p>'
            });
            buildToolbar({
                $toolbarWrapper,
                getEditorCore: () => editor,
            });
            vm.editor = editor;
            vm.buildScrollData();
        },
        computed: mapState({
            loginRediret: function (state) {
                return state.loginRediret;
            },
            addItem: function (state) {
                return state.addItem;
            },
            addDocument: function (state) {
                return state.addDocument;
            },
            selectDocument: function (state) {
                return state.selectDocument;
            },
            selectItemList: function (state) {
                return state.selectItemList;
            },
            getuserAPI: function (state) {
                return state.getuserAPI;
            },
            cookieName: function (state) {
                return state.cookieName;
            },
        }),
        methods: {
            buildScrollData() {
                let vm = this;
                // 监听dom渲染完成
                this.$nextTick(function () {
                    // 这里fixedHeaderRoot是吸顶元素的ID
                    let header = document.getElementById("toolbar");
                    // 这里要得到top的距离和元素自身的高度
                    vm.scroll.offsetTop = header.offsetTop;
                    vm.scroll.offsetHeight = header.offsetHeight;
                });
            },
            handleScroll() {
                // 得到页面滚动的距离
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // 判断页面滚动的距离是否大于吸顶元素的位置
                this.scroll.headerFixed = scrollTop > (this.scroll.offsetTop - this.scroll.offsetHeight);

            },
            getCookie(name) {
                var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
                if (arr = document.cookie.match(reg))
                    return unescape(arr[2]);
                else
                    return null;
            },
            async addContent() {
                var vm = this;
                var title = vm.currentTitle;
                let htmlInfo = vm.editor.value();
                var document = {documentIndex: vm.currentIndex, documentTitle: title, documentContent: htmlInfo}
                // 请求后端
                await axios.post(vm.addItem, vm.item, {
                    withCredentials: true
                }).then((response) => {
                }).catch(function (error) {
                    vm.requesterrorinfo(error)
                });
                if (vm.item.isDir == 0) {
                    // 请求后端保存编辑内容
                    await axios.post(vm.addDocument, document, {
                        withCredentials: true
                    }).then((response) => {
                        if (response.data.code == 2) {
                            vm.$notify({
                                title: '提示',
                                message: '添加文档成功！',
                                type: 'success'
                            });
                        }
                    }).catch(function (error) {
                        vm.requesterrorinfo(error)
                    });
                }
                this.$router.push({path: '/templateHtml', query: {index: vm.currentIndex}});
            }
        },
        data() {
            return {
                token: '',
                currentIndex: '',
                currentTitle: '',
                item: {},
                editor: null,
                scroll: {
                    offsetTop: 0,
                    offsetHeight: 0,
                    headerFixed: false
                }
            }
        }
    }
</script>

<style scoped>
    input.documentTitle {
        margin: 16px 0 8px;
        border: 0;
        font-size: 32px !important;
        font-weight: 700;
        background: none;
        resize: none;
        padding: 0 30px;
        width: 100%;
    }

    input.documentTitle:focus {
        border: none;
    }

    .edit-document-button {
        position: fixed;
        top: 100px;
        right: 60px;
        z-index: 1899;
    }

    .fix-button-top {
        top: 160px;
    }

    .isFixed {
        position: fixed;
        top: 60px;
        left: 300px;
        right: 20px;
        z-index: 1899;
    }

    #toolbar {
        background-color: rgba(255, 255, 255, 1);
    }

    .el-button.circle-button {
        padding: 12px !important;
        border-radius: 50% !important;
    }
</style>



// WEBPACK FOOTER //
// editorItem.vue?a6fe83c6